// Shared control styling for the visitor form's field groups, so every section
// renders the same input at the same size without repeating the class strings.
// Tailwind's JIT reads these as complete literals, which is why the error and
// default variants are spelled out rather than assembled from fragments.

export const labelCls = 'tw-block tw-text-[11px] tw-font-semibold tw-text-gray-700 tw-mb-1';
export const errorCls = 'tw-text-[10px] tw-text-rose-600 tw-mt-1';
export const hintCls = 'tw-text-[10px] tw-text-gray-400 tw-mt-1';

const BASE = 'tw-w-full tw-px-3 tw-py-2 tw-text-xs tw-border tw-rounded-md focus:tw-outline-none';
const OK = 'tw-border-gray-200 focus:tw-border-sky-500';
const BAD = 'tw-border-rose-400 focus:tw-border-rose-500';

export const controlCls = (hasError) => `${BASE} ${hasError ? BAD : OK}`;

// Same control, sized to its content rather than to its column. These forms are
// full-width pages, so a grid cell can run several hundred pixels — right for a
// name, absurd for a two-digit count.
const NARROW = 'tw-w-28 tw-px-3 tw-py-2 tw-text-xs tw-border tw-rounded-md focus:tw-outline-none';
export const numberCls = (hasError) => `${NARROW} ${hasError ? BAD : OK}`;

// Curried for the form: `const input = inputCls(errors)` then `input('name')`.
export const inputCls = (errors) => (field) => controlCls(!!errors?.[field]);
